import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    data: {
      title: 'manager Dashboard'
    }, 
    redirectTo: 'manager',
    pathMatch: 'full'
  },
  {
    path: 'question-bank',
    loadChildren: () => import('./modules/question-bank/question-bank.module').then(m => m.QuestionBankModule)
  },
  {
    path: 'upload-terms-conditions',
    loadChildren: () => import('./manager/upload-terms-conditions/upload-terms-condition.module').then(m => m.UploadTermsConditionsModule)
  },
 
  {
    path: 'sms-startbatch',
    loadChildren: () => import('./manager/sms-start-batch-password/sms-start-batch.module').then(m => m.SmsStartBatchModule)
  },
  {
    path: 'candidate-instruction',
    loadChildren: () => import('./manager/candidate-instruction/candidate-instruction.module').then(m => m.CandidateInstructionModule)
  },
  {
    path: 'exam',
    loadChildren: () => import('./manager/upload-exam-center-list/exam-center.module').then(m => m.ExamCenterModule)
  },


  {
    path: 'timing',
    loadChildren: () => import('./manager/upload-test-timing-detail/upload-test-timing-detail.module').then(m => m.TestTimingModule)
  },

  {
    path: 'survey-questions',
    loadChildren: () => import('./modules/survey-questions/survey-questions.module').then(m => m.SurveyQuestionsModule)
  },
  {
    path: 'test-config',
    loadChildren: () => import('./manager/test-configuration/test-configuration.module').then(m => m.TestConfigurationModule)
  },
  {
    path: 'ot-config',
    loadChildren: () => import('./modules/ot-configuration/ot-configuration.module').then(m => m.OtConfigurationModule)
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule)
  },
  {
    path: 'encrypted-zip',
    loadChildren: () => import('./manager/encrypted-zip/encrypted-zip.module').then(m => m.EncryptedZipModule)
  }
];


@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      paramsInheritanceStrategy: "always"
    })
  ],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }
